<template>
    <h1>Registrieren</h1>
    <p>
        Geben Sie Ihre persönlichen Daten ein.
    </p>
    <SelectedInstitution v-if="hasInstitution" :institutionName="institutionName" />
    <FormHome v-if="isHome" :registrationFormOptions="registrationFormOptions" :initial-registration-data="registrationData" @submitted="submitData"/>
    <FormKita v-if="isKita" :registrationFormOptions="registrationFormOptions" :initial-registration-data="registrationData" @submitted="submitData"/>
    <FormSchool v-if="isSchool" :registrationFormOptions="registrationFormOptions" :initial-registration-data="registrationData" @submitted="submitData"/>
    <FormWork v-if="isWork" :registrationFormOptions="registrationFormOptions" :initial-registration-data="registrationData" @submitted="submitData"/>
</template>

<script>
import FormHome from '@/views/components/ui/Register/Step1/Form/Home'
import FormKita from '@/views/components/ui/Register/Step1/Form/Kita'
import FormSchool from '@/views/components/ui/Register/Step1/Form/School'
import FormWork from '@/views/components/ui/Register/Step1/Form/Work'
import SelectedInstitution from '@/views/components/ui/Register/Step1/SelectedInstitution'

import { Destination } from '@/utils/registration'

export default {
    name: 'RegisterStep1InputData',
    components: {
        FormHome,
        FormKita,
        FormSchool,
        FormWork,
        SelectedInstitution,
    },
    props: {
        destination: {
            type: String,
            required: true,
            validator: value => {
                return Object.values(Destination).includes(value)
            }
        },
        registrationFormOptions: {
            type: [Object, null],
            default: null,
        },
        registrationData: [Object, null],
    },
    computed: {
        institutionName() {
            if (this.registrationFormOptions === null) {
                return ''
            }

            return this.registrationFormOptions.institutionName || ''
        },
        hasInstitution() {
            return this.institutionName !== ''
        },
        isKita() {
            return this.destination === Destination.Kita
        },
        isSchool() {
            return this.destination === Destination.School
        },
        isHome() {
            return this.destination === Destination.Home
        },
        isWork() {
            return this.destination === Destination.Work
        },
    },
    methods: {
        submitData(formData) {
            this.$emit('dataCollected', formData)
        }
    },
    emits: ['dataCollected'],
}
</script>
